module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/group-ordering-01-8d722a7eafc2de37beb0b3cb68167561.jpg";